import { h, render } from 'preact';
import { render as ssr } from 'preact-render-to-string';
import { App, Props as Parameters } from './App';
import { polyfills } from './polyfills';

polyfills();

// == Interfaces ===============================================================
export { App } from './App';
export type { CmsImageData } from './common/cmsTypes';
export type { Environment, Location, Locations, PaxAmount, PaxType, TravelDates } from './common/types';

export { TravelClass, WidgetTab, TravelType } from './common/types';

export type { EnvConfig } from './config/envConfig';
export * from './config/extensionApi';
export * from './config/abTests';
export type { Localizations } from './i18n/localizations';
export type { SelectionState } from './store/state';
export type { DeepPartial } from './utils/typeUtils';
export type { Parameters };
export interface RenderingOptions {
  /** If `true`, renders nested Components as HTML elements (`<Foo a="b" />`). */
  shallow?: boolean;
  /** If `true`, uses self-closing tags for elements without children. */
  xml?: boolean;
  /** If `true`, adds whitespace for readability */
  pretty?: boolean;
}

// == Functionality ============================================================
export { parseLocalizations } from './i18n/parseLocalizations';
export { updateState } from './store';
/**
 * Use this function when you want to render the booking-widget on the server side.
 * @param parameters Paramertes passed to the booking widget root App component
 * @param renderingOptions Preact rendering options
 * @returns SSR/stringified version of the booking-widget
 */
export const renderToString = (parameters?: Parameters, renderingOptions?: RenderingOptions): string =>
  ssr(h(App, parameters), {}, renderingOptions as any);
/**
 * Use this function when you want to render the booking-widget into an element in the DOM.
 * Calling this function multiple times with the same element will re-render the booking-widget's
 * root App component without unmounting it from the DOM. If you want to re-initialize the widget, you should
 * unmount the root component first with 'unmount'
 * @param element The booking-widget's host element into which the widget will be rendered
 * @param parameters An object containing properties for booking-widget's initialization and behaviour
 * @returns The rendered widget
 */
export const renderToElement = (element: HTMLElement, parameters?: Parameters) =>
  render(<App {...parameters} />, element);
/**
 * Use this function to unmount the booking-widget from the DOM. Calling this will clear all references
 * to widget's store and other internal elements and functionalities
 * @param element The booking-widget's host element into which the widget will be rendered
 * @returns Empty element
 */
export const unmount = (element: HTMLElement) => render(null, element);
